// extracted by mini-css-extract-plugin
export default {"backdrop":"OverlayWindow_backdrop__oj5tN","window":"OverlayWindow_window__F4b9n","grab":"OverlayWindow_grab__vsTjm","wrapper":"OverlayWindow_wrapper__57BGf"};